module.exports = __webpack_public_path__ + "img/icon-products.c24fea58.svg";